/**
 * User-facing error message formatting for lookup and fetch errors.
 * User-facing error message formatting for lookup and fetch errors.
 */
import { ApiError, AuthRequiredError } from "../../api/fetchWithAuth"

/**
 * Formats a fetch/API error for a resource lookup into a user-readable string.
 * @param error - The caught error value
 * @param resourceLabel - Human label for the resource type e.g. "Entity", "Fund"
 * @param id - The ID that was looked up (used in 404 message)
 */
export function formatResourceFetchErrorMessage(
	error: unknown,
	resourceLabel: string,
	id: string,
): string {
	if (error instanceof AuthRequiredError) {
		return "Authentication required. Please log in first."
	}
	if (error instanceof ApiError) {
		if (error.status === 404) {
			return `${resourceLabel} not found: "${id}". Check the ID and try again.`
		}
		if (error.status === 401) {
			return "Authentication failed. Please log in again."
		}
		return `Request failed (${error.status}): ${error.message}`
	}
	const msg = String(error)
	if (msg.includes("Failed to fetch") || msg.includes("NetworkError") || msg.includes("ERR_FAILED")) {
		return "Could not reach the API. Check that the REST API is running and CORS is configured."
	}
	return `Request failed: ${msg}`
}
